import React, { useState, useEffect } from 'react';
import { Widget, GridView, SimpleView, usePromise, Table } from '@digital/ui';
import FiltroMedicaoDashboard from './FiltroMedicaoDashboard';
import { getDashboardMedicaoData, DashboardMedicaoData, InformacaoContrato } from './@app/../../../api/dashboardMedicao';
import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Filter } from '@app/api/dashboardContratos';
import { compareDates, compareText } from '@app/helpers/comparators';

const DashboardMedicoes = () => {
  const [dashboardData, setDashboardData] = useState({} as DashboardMedicaoData);
  const [documentoAcessorioAtivo, setDocumentoAcessorioAtivo] = useState<boolean>(true);
  const [initialValue] = usePromise<DashboardMedicaoData>(getDashboardMedicaoData, [], {} as DashboardMedicaoData);

  const [statusBoletimMedicao, setStatusBoletimMedicao] = useState<InformacaoContrato[]>();
  const [statusAutorizacaoPagamentoContrato, setStatusAutorizacaoPagamentoContrato] = useState<InformacaoContrato[]>();
  const [statusMatching, setStatusMatching] = useState<InformacaoContrato[]>();

  const [totalStatusContrato, setTotalStatusContrato] = useState<number>(0);
  const [totalAutorizacaoPagamento, setTotalAutorizacaoPagamento] = useState<number>(0);
  const [totalStatusAutorizacaoMatching, setTotalStatusAutorizacaoMatching] = useState<number>(0);

  useEffect(() => {
    setDashboardData(initialValue);
    setDocumentoAcessorioAtivo(initialValue.gerirDocumentacaoAcessoria);

    setStatusBoletimMedicao(initialValue.statusBoletimMedicao);
    setStatusAutorizacaoPagamentoContrato(initialValue.statusAutorizacaoPagamentoContrato);
    setStatusMatching(initialValue.statusMatching);

    if (initialValue) {
      if (initialValue && initialValue.statusBoletimMedicao)
        setTotalStatusContrato(initialValue.statusBoletimMedicao.length);

      if (initialValue && initialValue.statusAutorizacaoPagamentoContrato)
        setTotalAutorizacaoPagamento(initialValue.statusAutorizacaoPagamentoContrato.length);

      if (initialValue && initialValue.statusMatching)
        setTotalStatusAutorizacaoMatching(initialValue.statusMatching.length);
    }
  }, [initialValue]);

  const optionsBM: Highcharts.Options = {
    chart: {
      type: 'column',
    },
    xAxis: {
      categories: dashboardData.statusBM ? dashboardData.statusBM.map(a => a.name) : [],
      labels: {
        enabled: false,
      },
    },
    plotOptions: {
      column: {
        stacking: 'normal',
      },
    },
    legend: {
      labelFormatter: function () {
        if (this.data.length > 0) {
          return this.data[0].category;
        } else {
          return this.name;
        }
      },
    },
    tooltip: { pointFormat: 'Status: <b>{point.y:.1f}</b>' },
    colors: [
      '#fc8e5b',
      '#a6ba59',
      '#d8483d',
      '#906380',
      '#e9c382',
      '#39a693',
      '#37889b',
      '#9f8141',
      '#7a9970',
      '#fc5856',
    ],
    yAxis: {
      min: 0,
      title: {
        text: '',
      },
    },
    title: { text: '' },
    series: dashboardData.statusBM,
  };

  const optionsDAM: Highcharts.Options = {
    chart: {
      type: 'column',
    },
    xAxis: {
      categories: dashboardData.statusDocumentacaoAcessoriaMensal
        ? dashboardData.statusDocumentacaoAcessoriaMensal.map(a => a.name)
        : [],
      labels: { enabled: false },
    },
    plotOptions: {
      column: { stacking: 'normal' },
    },
    legend: {
      labelFormatter: function () {
        if (this.data.length > 0) {
          return this.data[0].category;
        } else {
          return this.name;
        }
      },
    },
    tooltip: { pointFormat: 'Status: <b>{point.y:.1f}</b>' },
    colors: ['#c42525', '#f28f43', '#a6c96a'],
    yAxis: {
      min: 0,
      title: {
        text: '',
      },
    },
    title: { text: '' },
    series: dashboardData.statusDocumentacaoAcessoriaMensal,
  };

  const optionsAP: Highcharts.Options = {
    chart: {
      type: 'column',
    },
    xAxis: {
      categories: dashboardData.statusAutorizacaoPagamento
        ? dashboardData.statusAutorizacaoPagamento.map(a => a.name)
        : [],
      labels: {
        enabled: false,
      },
    },
    plotOptions: {
      column: {
        stacking: 'normal',
      },
    },
    legend: {
      labelFormatter: function () {
        if (this.data.length > 0) {
          return this.data[0].category;
        } else {
          return this.name;
        }
      },
    },
    tooltip: { pointFormat: 'Status: <b>{point.y:.1f}</b>' },
    colors: [
      '#fc8e5b',
      '#a6ba59',
      '#d8483d',
      '#906380',
      '#e9c382',
      '#39a693',
      '#37889b',
      '#9f8141',
      '#7a9970',
      '#fc5856',
    ],
    yAxis: {
      min: 0,
      title: {
        text: '',
      },
    },
    title: { text: '' },
    series: dashboardData.statusAutorizacaoPagamento,
  };

  const optionsAM: Highcharts.Options = {
    chart: {
      type: 'column',
    },
    xAxis: {
      categories: dashboardData.statusAutorizacaoMatching
        ? dashboardData.statusAutorizacaoMatching.map(a => a.name)
        : [],
      labels: {
        enabled: false,
      },
    },
    plotOptions: {
      column: {
        stacking: 'normal',
      },
    },
    legend: {
      labelFormatter: function () {
        if (this.data.length > 0) {
          return this.data[0].category;
        } else {
          return this.name;
        }
      },
    },
    tooltip: { pointFormat: 'Status: <b>{point.y:.1f}</b>' },
    colors: [
      '#fc8e5b',
      '#39a693',
      '#906380',
      '#d8483d',
      '#e9c382',
      '#a6ba59',
    ],
    yAxis: {
      min: 0,
      title: {
        text: '',
      },
    },
    title: { text: '' },
    series: dashboardData.statusAutorizacaoMatching,
  };

  const handleFilter = (values: Filter) => {
    getDashboardMedicaoData(values).then(resp => {
      setDashboardData(resp);
      setDocumentoAcessorioAtivo(resp.gerirDocumentacaoAcessoria);

      setStatusBoletimMedicao(resp.statusBoletimMedicao);
      setStatusAutorizacaoPagamentoContrato(resp.statusAutorizacaoPagamentoContrato);
      setStatusMatching(resp.statusMatching);

      if (resp) {
        if (resp && resp.statusBoletimMedicao)
          setTotalStatusContrato(resp.statusBoletimMedicao.length);

        if (resp && resp.statusAutorizacaoPagamentoContrato)
          setTotalAutorizacaoPagamento(resp.statusAutorizacaoPagamentoContrato.length);

        if (resp && resp.statusMatching)
          setTotalStatusAutorizacaoMatching(resp.statusMatching.length);
      }


    });
  };

  const colunaTable = [
    {
      title: 'Contrato',
      dataIndex: 'numero',
      width: '20%',
      sorter: (a, b) => compareText(a.fornecedor, b.fornecedor),
    },
    {
      title: 'BM',
      dataIndex: 'numeroBoletim',
      width: '5%',
      sorter: (a, b) => compareText(a.fornecedor, b.fornecedor),
    },
    {
      title: 'Fornecedor',
      dataIndex: 'fornecedor',
      width: '40%',
      sorter: (a, b) => compareText(a.fornecedor, b.fornecedor),
    },
    {
      title: 'Data Inicio',
      dataIndex: 'dataInicioFormatada',
      width: '20%',
      sorter: (a, b) => compareDates(a.dataInicioFormatada, b.dataInicioFormatada),
    },
    {
      title: 'Data Final',
      dataIndex: 'dataFimFormatada',
      width: '20%',
      sorter: (a, b) => compareDates(a.dataInicioFormatada, b.dataInicioFormatada),
    },
  ]

  const divStyle = {
    fontWeight: 'bold',
    textAlign: 'right'
  };

  function ComponentWithTransition(totalRegristro: number) {
    return <div style={divStyle}>{`Total de Medições: ${totalRegristro}`}</div>;
  }


  return (
    <SimpleView>
      <GridView noform>
        <FiltroMedicaoDashboard onSearch={handleFilter} />
        <Widget title="Status Boletim de Medição" span={4}>
          <HighchartsReact highcharts={Highcharts} options={optionsBM} />
          <Table
            className="status-boletim-medicao-table"
            columns={colunaTable}
            rowKey='idTemporario'
            dataSource={statusBoletimMedicao}
            footer={() => { return ComponentWithTransition(totalStatusContrato) }}
          />
        </Widget>
        {documentoAcessorioAtivo ? (
          <Widget title="Status Documentação Acessória Mensal" span={4}>
            <HighchartsReact highcharts={Highcharts} options={optionsDAM} />
          </Widget>)
          :
          (<> </>)}
        <Widget title="Status Autorização/Pagamento" span={4}>
          <HighchartsReact highcharts={Highcharts} options={optionsAP} />
          <Table
            className="status-boletim-medicao-table"
            columns={colunaTable}
            rowKey='idTemporario'
            dataSource={statusAutorizacaoPagamentoContrato}
            footer={() => { return ComponentWithTransition(totalAutorizacaoPagamento) }}
          />
        </Widget>
        <Widget title="Status Autorização 'Matching'" span={4}>
          <HighchartsReact highcharts={Highcharts} options={optionsAM} />
          <Table
            className="status-boletim-medicao-table"
            columns={colunaTable}
            rowKey='idTemporario'
            dataSource={statusMatching}
            footer={() => { return ComponentWithTransition(totalStatusAutorizacaoMatching) }}
          />
        </Widget>
      </GridView>
    </SimpleView>
  );
};

export default DashboardMedicoes;
